//
// Module for the Seminars index page
//
rs.module("content/fund/account/seminars/index",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(lrsGridApi, jsSelectors, backendUrl) {
            var filter = $.js(jsSelectors.filter);
            var includePastCheckbox = filter.js(jsSelectors.includePastCheckbox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includePastCheckbox.change(includePastChanged);

            /**
             * Hookup Ajax to changed checkbox selection
             */
            function includePastChanged() {
                loadingSpinner.show();
                gridModule.update(
                    backendUrl,

                    { includePast : includePastCheckbox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                    }).always(function () {
                    loadingSpinner.hide();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);